import { getCodeList } from 'country-list';
import { BillingData } from 'business-layer/types/BillingData';
import { TBillingData } from 'data-layer/dto/PaymentGatewayDto';

const prepareCountries = (countriesObj: Record<string, string>) => {
  const list = getCodeList();
  return Object.keys(list).map(el => ({
    name: list[el],
    value: el.toUpperCase(),
  }));
}

interface DefaultBillingData extends BillingData {
  id: string;
}

export const BillingDefault: DefaultBillingData[] = [
  {
    id: 'email',
    label: 'Billing E-mail',
    name: 'billingEmail',
    isRequired: false,
  },
  {
    id: 'address1',
    label: 'Billing Address',
    name: 'billingAddress',
    isRequired: false,
  },
  {
    id: 'address2',
    label: 'Billing Address 2',
    name: 'billingAddress2',
    isRequired: false,
  },
  {
    id: 'city',
    label: 'Billing City',
    name: 'billingCity',
    isRequired: false,
  },
  {
    id: 'zip',
    label: 'Billing Zip',
    name: 'billingZip',
    isRequired: false,
  },
  {
    id: 'state',
    label: 'Billing State',
    name: 'billingState',
    isRequired: false,
  },
  {
    id: 'country',
    label: 'Billing Country',
    name: 'billingCountry',
    isRequired: false,
    options: prepareCountries(getCodeList()),
    // options: [
    //   { name: 'United States', value: 'US' },
    //   { name: 'Canada', value: 'CA' },
    //   { name: 'Mexico', value: 'MX' },
    //   { name: 'Brazil', value: 'BR' },
    // ],
  },
];

const DisplaySuffix = '_billing_address_display';
const MandatorySuffix = '_billing_address_mandatory';

export const parseBillingAddressFields = (data: TBillingData): BillingData[] => {
  const keys = Object.keys(data);
  return BillingDefault
    .filter((el: DefaultBillingData) => keys.includes(`${el.id}${DisplaySuffix}`))
    .map((el: DefaultBillingData) => ({
      ...el,
      isRequired: keys.includes(`${el.id}${MandatorySuffix}`),
    }));
}
